import ddt from '@wix/da-ddt';
import { toJsonString, isSSR } from '../utils';
export const DEV_SCRIPT_URL = 'https://s.nitropay.com/ads-1240.js';
export const PROD_SCRIPT_URL = 'https://s.nitropay.com/ads-1239.js';
class NitroAds {
    init(biLogger) {
        if (!isSSR()) {
            // Replay events that happen before react lives
            if (window.__DAADS__ && Array.isArray(window.__DAADS__.ev)) {
                for (const storedEvt of window.__DAADS__.ev){
                    ddt.log('ads', `nitro boot evt ${storedEvt.ev}`, storedEvt === null || storedEvt === void 0 ? void 0 : storedEvt.e);
                }
                window.__DAADS__.ev = false;
            }
            // Events for BI/Debug
            document.addEventListener('nitroAds.loaded', (event)=>{
                ddt.log('ads', 'nitro evt loaded', event === null || event === void 0 ? void 0 : event.detail);
            });
            document.addEventListener('nitroAds.createAd', (event)=>{
                ddt.log('ads', 'nitro evt createAd', event === null || event === void 0 ? void 0 : event.detail);
            });
            document.addEventListener('nitroAds.prepare', (event)=>{
                ddt.log('ads', 'nitro evt prepare', event === null || event === void 0 ? void 0 : event.detail);
            });
            document.addEventListener('nitroAds.bidReceived', (event)=>{
                ddt.log('ads', 'nitro evt bid', event === null || event === void 0 ? void 0 : event.detail);
            });
            document.addEventListener('nitroAds.rendered', (event)=>{
                ddt.log('ads', 'nitro evt rendered', event === null || event === void 0 ? void 0 : event.detail);
            });
            document.addEventListener('nitroAds.anchorVisibility', (event)=>{
                ddt.log('ads', 'nitro evt anchorVis', event === null || event === void 0 ? void 0 : event.detail);
            });
            document.addEventListener('nitroAds.complete', (event)=>{
                ddt.log('ads', 'nitro evt complete', event === null || event === void 0 ? void 0 : event.detail);
            });
        }
    }
    registerUnit(unitId, options) {
        if (!isSSR()) {
            ddt.log('ads', 'register nitro client ad', unitId);
            window['nitroAds'].createAd(unitId, options);
        } else {
            ddt.log('ads', 'register nitro ssr ad', unitId);
            this.ssrUnits[unitId] = options;
        }
    }
    killUnit(unitId) {
    // noop as nitro auto cleanup once the ad is removed from DOM
    }
    toSSR() {
        let output = '';
        for (const key of Object.keys(this.ssrUnits)){
            output = `${output}\nwindow["nitroAds"].createAd("${key}", JSON.parse(${toJsonString(this.ssrUnits[key])}));`;
        }
        return output;
    }
    constructor(){
        this.ssrUnits = {};
    }
}
export default NitroAds;
